import { Injectable, NgZone } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SeaPriceDetailDialogComponent } from 'src/app/components/sea-price-detail-dialog/sea-price-detail-dialog.component';
import { SeaSearchService } from 'src/app/services/sea/sea-search.service';
import { StepperService } from 'src/app/stepper.service';
import { MarketSeaProductsModel } from 'src/app/models/sea/market-sea-products.model';
import { SeaModel } from 'src/app/models/sea/sea-model';
import { Router } from '@angular/router';
import { SeaPriceRequestComponent } from 'src/app/pages/sea/price-request/price-request.component';
import { SearchLogClickHistoryModel } from 'src/app/models/search-log-click-history.model';
import { SearchLogClickHistoryService } from '../search-log-click-history.service';

@Injectable({ providedIn: 'root' })
export class SeaPriceActionService {
  adminDialogRef: DynamicDialogRef;
    
    public pendingReservation: { model: any, product: any } = null;
  
    private lastClickHistoryAt = 0;

  constructor(
    private dialogService: DialogService,
    private ngZone: NgZone,
    private seaSearchService: SeaSearchService,
    private stepperService: StepperService,
    private searchLogHistoryService: SearchLogClickHistoryService,
    private router: Router
  ) {}

 

  async openPriceInfo(product: MarketSeaProductsModel, model: SeaModel, parentComponent: any, redirect = false) {
    
    const history = await this.createClickHistory(product, model);
    if(history && product) {
      product.history = history;
    }

    parentComponent.isDialogPriceOpen = true;
    this.ngZone.run(() => {
      this.adminDialogRef = this.dialogService.open(SeaPriceDetailDialogComponent, {
        header: null,
        showHeader: false,
        modal: true,
        width: '1000px',
        height: 'auto',
        closable: false,
        data: { 
          product: product, 
          model: model, 
          parentComponent: parentComponent, 
          showButton: true 
        }
      });
    });

    const closeSub = this.adminDialogRef.onClose.subscribe((data) => {
      if (parentComponent instanceof SeaPriceRequestComponent) {
        parentComponent.makeReservation(data.selectedProduct, data.marketProductsDefId, data.productId, data.makeReservation); 

        return;
    }

      parentComponent.isDialogPriceOpen = false;
      if (data && data.makeReservation) {
-        // Navigasyonun çalışması için Zone içine alıyoruz
        this.ngZone.run(() => {
            this.executeSingleReservation(model, data.selectedProduct, parentComponent, redirect);
        });
      }
      closeSub.unsubscribe();
    });
  }

    async executeSingleReservation(model: SeaModel, selectedProduct: MarketSeaProductsModel, parent: any, redirect = false) {
      this.pendingReservation = { model, product: selectedProduct };

  
      this.ngZone.run(() => {
          // SeaComponent'teki queryParams kontrolüyle eşleşmeli  
          this.router.navigate(['/home/sea'], { queryParams: {redirect} });
      });
    
    if (parent) parent.isLoading = false;
  }

  async createClickHistory(product: MarketSeaProductsModel, model: SeaModel ) {

      
    const now = Date.now();
    if (now - this.lastClickHistoryAt < 200) {
      return null;
    }
    this.lastClickHistoryAt = now;
      let history = new SearchLogClickHistoryModel();
      history.searchLogId = model?.id || null;
      history.productId = product?.id;
      history.productName = product?.name;
      history.uuid = product?.uuid;
      history.viewType = 'PRODUCTVIEW';
      history.info = 'LISTVIEW';

      history = await this.searchLogHistoryService.create(history).toPromise();
      return history;
  }


}